export const LOGIN_CUSTOMER = 'LOGIN_CUSTOMER'
export const LOGOUT_CUSTOMER = 'LOGOUT_CUSTOMER'
export const SET_LOGGED_IN_CUSTOMER = 'SET_LOGGED_IN_CUSTOMER'
export const SET_TOKEN = 'SET_TOKEN'
export const SET_HEADER = 'SET_HEADER'
export const SET_ADMIN = 'SET_ADMIN'

export const SET_CATEGORY_TO_CREATE = 'SET_CATEGORY_TO_CREATE'
export const SET_CATEGORY_TO_UPDATE = 'SET_CATEGORY_TO_UPDATE'
export const SET_CATEGORIES = 'SET_CATEGORIES'
export const SET_SEARCHED_CATEGORIES = 'SET_SEARCHED_CATEGORIES'
export const SET_ASSIGNABLE_CATEGORIES = 'SET_ASSIGNABLE_CATEGORIES'
export const SET_CATEGORY_CODES = 'SET_CATEGORY_CODES'
export const SET_TOP_CATEGORIES = 'SET_TOP_CATEGORIES'
export const SET_CATEGORY_CREATED = 'SET_CATEGORY_CREATED'
export const SET_CATEGORY_UPDATED = 'SET_CATEGORY_UPDATED'
export const SET_CATEGORY_DELETED = 'SET_CATEGORY_DELETED'
export const ADD_CATEGORY_TO_CATEGORIES = 'ADD_CATEGORY_TO_CATEGORIES'
export const ADD_CATEGORY_TO_TOP_CATEGORIES = 'ADD_CATEGORY_TO_TOP_CATEGORIES'
export const EDIT_CATEGORY_IN_SUB_LIST = 'EDIT_CATEGORY_IN_SUB_LIST'
export const EDIT_CATEGORY_IN_TOP_LIST = 'EDIT_CATEGORY_IN_TOP_LIST'
export const REMOVE_CATEGORY_FROM_CATEGORIES = 'REMOVE_CATEGORY_FROM_CATEGORIES'
export const SET_CATEGORY_INFO_TO_CREATE = 'SET_CATEGORY_INFO_TO_CREATE'
export const SET_CATEGORY_INFO_SAVED = 'SET_CATEGORY_INFO_SAVED'
export const SET_CATEGORY_INFO = 'SET_CATEGORY_INFO'

export const SET_BRAND_TO_CREATE = 'SET_BRAND_TO_CREATE'
export const SET_BRAND_TO_EDIT = 'SET_BRAND_TO_EDIT'
export const SET_BRANDS = 'SET_BRANDS'
export const SET_BRAND_CREATED = 'SET_BRAND_CREATED'
export const SET_BRAND_DELETED = 'SET_BRAND_DELETED'
export const SET_BRAND_EDITED = 'SET_BRAND_EDITED'
export const ADD_BRAND_TO_BRANDS = 'ADD_BRAND_TO_BRANDS'
export const SET_BRANDS_FOR_CATEGORY = 'SET_BRANDS_FOR_CATEGORY'
export const EDIT_BRAND_IN_BRANDS = 'EDIT_BRAND_IN_BRANDS'
export const REMOVE_BRAND_FROM_BRANDS = 'REMOVE_BRAND_FROM_BRANDS'

export const SET_PRODUCT_TO_CREATE = 'SET_PRODUCT_TO_CREATE'
export const SET_PRODUCT_TO_UPDATE = 'SET_PRODUCT_TO_UPDATE'
export const SET_PRODUCTS = 'SET_PRODUCTS'
export const SET_PRODUCT = 'SET_PRODUCT'
export const SET_PRODUCT_CREATED = 'SET_PRODUCT_CREATED'
export const SET_PRODUCT_UPDATED = 'SET_PRODUCT_UPDATED'
export const SET_PRODUCT_DELETED = 'SET_PRODUCT_DELETED'
export const SET_CATEGORY_NAME_ON_PRODUCT = 'SET_CATEGORY_NAME_ON_PRODUCT'
export const SET_CATEGORY_ID_ON_PRODUCT = 'SET_CATEGORY_ID_ON_PRODUCT'
export const ADD_PRODUCT_TO_PRODUCTS = 'ADD_PRODUCT_TO_PRODUCTS'
export const REMOVE_PRODUCT_FROM_PRODUCTS = 'REMOVE_PRODUCT_FROM_PRODUCTS'
export const ADD_PRODUCT_TO_SHOPPING_CART = 'ADD_PRODUCT_TO_SHOPPING_CART'
export const EDIT_PRODUCT_IN_SHOPPING_CART = 'EDIT_PRODUCT_IN_SHOPPING_CART'
export const REMOVE_PRODUCT_FROM_SHOPPING_CART = 'REMOVE_PRODUCT_FROM_SHOPPING_CART'
export const SET_PRODUCTS_IN_SHOPPING_CART = 'SET_PRODUCTS_IN_SHOPPING_CART'
export const ADD_DISCOUNTS_TO_PRODUCTS_IN_SHOPPINGCART = 'ADD_DISCOUNTS_TO_PRODUCTS_IN_SHOPPINGCART'
export const ADD_DISCOUNTS_TO_PRODUCTS = 'ADD_DISCOUNTS_TO_PRODUCTS'
export const ADD_CUSTOMER_SPECIFIC_PRICES_TO_PRODUCTS = 'ADD_CUSTOMER_SPECIFIC_PRICES_TO_PRODUCTS'
export const ADD_CUSTOMER_SPECIFIC_PRICES_TO_PRODUCTS_IN_SHOPPINGCART = 'ADD_CUSTOMER_SPECIFIC_PRICES_TO_PRODUCTS_IN_SHOPPINGCART'
export const SET_SHOPPING_CART_TO_SAVE = 'SET_SHOPPING_CART_TO_SAVE'
export const EDIT_PRODUCT_IN_LIST = 'EDIT_PRODUCT_IN_LIST'
export const ADD_PRICE_TO_PRODUCT_BULK_PRICES = 'ADD_PRICE_TO_PRODUCT_BULK_PRICES'
export const REMOVE_PRICE_FROM_PRODUCT_BULK_PRICES = 'REMOVE_PRICE_FROM_PRODUCT_BULK_PRICES'
export const SET_PRODUCT_BULK_PRICES = 'SET_PRODUCT_BULK_PRICES'
export const SET_PRODUCT_BULK_PRICES_TO_CREATE = 'SET_PRODUCT_BULK_PRICES_TO_CREATE'
export const SET_PRODUCT_BULK_PRICES_CREATED = 'SET_PRODUCT_BULK_PRICES_CREATED'

export const SET_CUSTOMER_TO_CREATE = 'SET_CUSTOMER_TO_CREATE'
export const SET_CUSTOMER_TO_EDIT = 'SET_CUSTOMER_TO_EDIT'
export const SET_CUSTOMER_TO_UPDATE = 'SET_CUSTOMER_TO_UPDATE'
export const SET_CREATED_CUSTOMER = 'SET_CREATED_CUSTOMER'
export const SET_CUSTOMER = 'SET_CUSTOMER'
export const SET_CUSTOMERS = 'SET_CUSTOMERS'
export const SET_CUSTOMER_CREATED = 'SET_CUSTOMER_CREATED'
export const SET_CUSTOMER_UPDATED = 'SET_CUSTOMER_UPDATED'
export const SET_CUSTOMER_DELETED = 'SET_CUSTOMER_DELETED'
export const ADD_CUSTOMER_TO_CUSTOMERS = 'ADD_CUSTOMER_TO_CUSTOMERS'
export const REMOVE_CUSTOMER_FROM_CUSTOMERS = 'REMOVE_CUSTOMER_FROM_CUSTOMERS'
export const ADD_PRICE_TO_CUSTOMER_SPECIFIC_PRICES = 'ADD_PRICE_TO_CUSTOMER_SPECIFIC_PRICES'
export const REMOVE_PRICE_TO_CUSTOMER_SPECIFIC_PRICES = 'REMOVE_PRICE_TO_CUSTOMER_SPECIFIC_PRICES'
export const SET_CUSTOMER_SPECIFIC_PRICES = 'SET_CUSTOMER_SPECIFIC_PRICES'
export const SET_CUSTOMER_SPECIFIC_PRICES_TO_CREATE = 'SET_CUSTOMER_SPECIFIC_PRICES_TO_CREATE'
export const SET_CUSTOMER_SPECIFIC_PRICES_CREATED = 'SET_CUSTOMER_SPECIFIC_PRICES_CREATED'

export const SET_ACTION_TO_CREATE = 'SET_ACTION_TO_CREATE'
export const SET_ACTIONS = 'SET_ACTIONS'
export const SET_ACTION_CREATED = 'SET_ACTION_CREATED'
export const SET_ACTION_DELETED = 'SET_ACTION_DELETED'
export const ADD_ACTION_TO_ACTIONS = 'ADD_ACTION_TO_ACTIONS'
export const REMOVE_ACTIONS_FROM_ACTIONS = 'REMOVE_ACTIONS_FROM_ACTIONS'

export const SET_DISCOUNT_TO_CREATE = 'SET_DISCOUNT_TO_CREATE'
export const SET_DISCOUNTS = 'SET_DISCOUNTS'
export const SET_DISCOUNT_CREATED = 'SET_DISCOUNT_CREATED'
export const ADD_DISCOUNT_TO_DISCOUNTS = 'ADD_DISCOUNT_TO_DISCOUNTS'

export const SET_ORDER_TO_CREATE = 'SET_ORDER_TO_CREATE'
export const SET_ORDER_ITEM_TO_CREATE = 'SET_ORDER_ITEM_TO_CREATE'
export const SET_ORDER_IS_CREATED = 'SET_ORDER_IS_CREATED'
export const SET_ORDER_ITEM_IS_CREATED = 'SET_ORDER_ITEM_IS_CREATED'
export const SET_ORDER_ITEM_IS_DELETED = 'SET_ORDER_ITEM_IS_DELETED'
export const SET_ORDER = 'SET_ORDER'
export const SET_ORDER_ITEMS = 'SET_ORDER_ITEMS'
export const SET_ORDER_ITEMS_COPIED = 'SET_ORDER_ITEMS_COPIED'
export const SET_ORDER_ITEMS_FILTERED = 'SET_ORDER_ITEMS_FILTERED'
export const ADD_ORDER_ITEM_TO_ORDER_ITEMS = 'ADD_ORDER_ITEM_TO_ORDER_ITEMS'
export const REMOVE_ORDERITEM_FROM_ORDERITEMS_FILTERED = 'REMOVE_ORDERITEM_FROM_ORDERITEMS_FILTERED'

export const SET_IMAGE_LOCATION = 'SET_IMAGE_LOCATION'
export const SET_DOCUMENT_LOCATION = 'SET_DOCUMENT_LOCATION'

export const SET_MAIL_TO_SEND = 'SET_MAIL_TO_SEND'
export const SET_MAIL_IS_SENT = 'SET_MAIL_IS_SENT'
export const SET_ORDER_MAIL_IS_SENT = 'SET_ORDER_MAIL_IS_SENT'

export const SET_ACTIVE_SCREEN = 'SET_ACTIVE_SCREEN'
export const SET_BREADCRUMBS = 'SET_BREADCRUMBS'
export const ADD_BREADCRUMB = 'ADD_BREADCRUMB'
export const REMOVE_BREADCRUMB = 'REMOVE_BREADCRUMB'

export const SET_CATEGORY_TO_SWITCH = 'SET_CATEGORY_TO_SWITCH'
export const SET_CATEGORY_SWITCHED = 'SET_CATEGORY_SWITCHED'

export const SET_PRICES_CHANGED = 'SET_PRICES_CHANGED'

export const SET_PRODUCTS_IMPORTED = 'SET_PRODUCTS_IMPORTED'

export const SET_QUOTE_TO_CREATE = 'SET_QUOTE_TO_CREATE'
export const SET_QUOTE_MAIL_IS_SENT = 'SET_QUOTE_MAIL_IS_SENT'

export const SET_JOB_TO_CREATE = 'SET_JOB_TO_CREATE'
export const SET_JOB_TO_UPDATE = 'SET_JOB_TO_UPDATE'
export const SET_JOBS = 'SET_JOBS'
export const SET_JOB = 'SET_JOB'
export const SET_JOB_CREATED = 'SET_JOB_CREATED'
export const SET_JOB_UPDATED = 'SET_JOB_UPDATED'
export const SET_JOB_DELETED = 'SET_JOB_DELETED'
export const ADD_JOB_TO_JOBS = 'ADD_JOB_TO_JOBS'
export const REMOVE_JOB_FROM_JOBS = 'REMOVE_JOB_FROM_JOBS'
export const EDIT_JOB_IN_LIST = 'EDIT_JOB_IN_LIST'